const getNestedTiptapDocument = (value) => {
  const content = value?.content
  if (!Array.isArray(content) || content.length !== 1) return null

  const paragraphContent = content[0]?.content
  if (!Array.isArray(paragraphContent) || paragraphContent.length !== 1) {
    return null
  }

  const text = paragraphContent[0]?.text
  if (typeof text !== 'string') return null

  try {
    const parsed = JSON.parse(text)
    return parsed?.type === 'doc' ? parsed : null
  } catch {
    return null
  }
}

export const normalizeTiptapValue = (value) => {
  let normalizedValue = value

  for (let i = 0; i < 5; i += 1) {
    if (typeof normalizedValue === 'string') {
      try {
        const parsed = JSON.parse(normalizedValue)
        if (parsed?.type !== 'doc') return normalizedValue
        normalizedValue = parsed
        continue
      } catch {
        return normalizedValue
      }
    }

    const nestedDocument = getNestedTiptapDocument(normalizedValue)
    if (!nestedDocument) return normalizedValue
    normalizedValue = nestedDocument
  }

  return normalizedValue
}
